import { useState } from "react";
import type { SimulatorAppSurfaceProps } from "../AppSurface.js";

const keys = ["7", "8", "9", "/", "4", "5", "6", "*", "1", "2", "3", "-", "0", ".", "=", "+"];

function calculate(expression: string): string {
  const match = expression.match(/^(-?\d+(?:\.\d+)?)([+\-*/])(-?\d+(?:\.\d+)?)$/);
  if (!match) return expression || "0";
  const left = Number(match[1]);
  const right = Number(match[3]);
  const value = match[2] === "+"
    ? left + right
    : match[2] === "-"
      ? left - right
      : match[2] === "*"
        ? left * right
        : right === 0
          ? NaN
          : left / right;
  return Number.isFinite(value) ? String(Number(value.toFixed(6))) : "Error";
}

export function CalculatorApp({ activeMachine, onRunCommand }: SimulatorAppSurfaceProps) {
  const [expression, setExpression] = useState("12+30");
  const [result, setResult] = useState("42");

  async function record(nextResult = result) {
    await onRunCommand({
      appId: "calc",
      commandType: "CALC_RECORD_RESULT",
      capability: "local.utility.read",
      label: `Calculator result ${nextResult}`,
      payload: { expression, machineId: activeMachine, result: nextResult }
    });
  }

  function press(key: string) {
    if (key === "=") {
      const next = calculate(expression.replace(/\s+/g, ""));
      setResult(next);
      void record(next);
      return;
    }
    setExpression((current) => current === "0" ? key : `${current}${key}`);
  }

  return (
    <div className="fd-sim-app fd-calculator">
      <div className="fd-calculator-display">
        <input aria-label="Calculator expression" value={expression} onChange={(event) => setExpression(event.target.value)} />
        <strong>{result}</strong>
      </div>
      <div className="fd-calculator-grid">
        <button type="button" onClick={() => { setExpression(""); setResult("0"); }}>C</button>
        <button type="button" onClick={() => setExpression((current) => current.slice(0, -1))}>Back</button>
        <button type="button" onClick={() => void record()}>Record</button>
        {keys.map((key) => (
          <button className={/[+\-*/=]/.test(key) ? "is-op" : ""} key={key} type="button" onClick={() => press(key)}>
            {key}
          </button>
        ))}
      </div>
    </div>
  );
}
